import axios from "axios";
const AxiosInstance = axios.create({
  // baseURL: "https://api.treatwalk.com/api",
  baseURL: "https://devapitreatwalk.equitysoft.tech/api",
});
AxiosInstance.interceptors.request.use(
  function (config) {
    const traetwalk = JSON.parse(localStorage.getItem("TREATWALK"));
    config.headers.token = traetwalk?.token;
    config.headers.apikey = traetwalk?.apikey;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem("userInfo");
        window.location.pathname = "/";
      } else {
        console.error("Response Error:", error.response);
      }
    } else if (error.request) {
      console.error("Request Error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance